export const DIMENSION_TAG = 'TAG';

export default (dimension) => {
  if (typeof dimension === 'string') {
    return dimension;
  }
  if (dimension.field === DIMENSION_TAG) {
    // NOTE: dimension.groupBy might contain '='
    return `${dimension.field}=${dimension.groupBy}`;
  }
  return dimension.field;
};
